import { animate, style, transition, trigger } from '@angular/animations';

export const fadeIn = trigger('routeAnimations', [
  // fade in when created. this could also be written as transition('void => *')
  transition('* <=> *', [style({ opacity: 0 }), animate(300)]),
]);
